var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "c-survey__skip-button",
      class: {},
      attrs: { href: "#", target: "_self" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.doButtonAction.apply(null, arguments)
        },
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.title) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }